// M3 · Switch buddy (QM3_Switch): what comes along, what stays, the four buddies, and a confirm sheet
// (POST /api/buddy/switch). After switching, Chat opens with the new buddy (the server adds their greeting).
import { useState } from 'preact/hooks';
import type { CharId } from '@shared/types';
import { CHAR_IDS } from '@shared/types';
import { C } from '@shared/content/characters';
import { useApp, switchBuddy } from '../../store';
import { back, reset } from '../../router';
import { Screen, ScrollArea, IconButton, XFace, Icon, BottomSheet, PrimaryButton, TextButton } from '../../components';
import { plural } from '../us/route';
import { ME } from './copy';
import s from './me.module.css';

export function SwitchScreen() {
  const st = useApp((x) => x.state);
  const [target, setTarget] = useState<CharId | null>(null);
  const [busy, setBusy] = useState(false);
  if (!st) return <Screen theme="margo" id="M3" />;
  const ch = st.ch, c = C[ch];
  const t = target ? C[target] : null;

  const doSwitch = async () => {
    if (!target || busy) return;
    setBusy(true);
    const r = await switchBuddy(target);
    setBusy(false);
    setTarget(null);
    if (r) reset('C');
  };

  return (
    <Screen theme={ch} id="M3">
      <header class={s.bar}>
        <IconButton icon="back" label="Back" class={s.back} onClick={() => back('M2')} />
        <h1 class={s.barTitle}>Switch buddy</h1>
      </header>
      <ScrollArea class={s.scroll}>
        <div class={`${s.list} ${s.switchList}`}>
          <section class={`${s.card} ${s.comes}`} aria-label="Comes with you">
            <p class={s.cap} style={{ marginBottom: 6 }}>COMES WITH YOU</p>
            {ME.comes(plural(st.streak.count, 'day')).map((x) => (
              <p class={s.comesRow} key={x}><Icon name="check" size={16} strokeWidth={2.6} color="var(--acc)" /><span>{x}</span></p>
            ))}
          </section>
          <section class={s.stays} aria-label={`Stays with ${c.name}`}>
            <p class={s.cap}>{`STAYS WITH ${c.name.toUpperCase()}`}</p>
            <p class={s.staysT}>{ME.stays(c.name, c.obj)}</p>
          </section>
          {CHAR_IDS.map((id) => {
            const p = C[id], cur = id === ch;
            return (
              <button
                type="button" class={s.person} key={id} aria-pressed={cur ? 'true' : 'false'}
                style={{ ['--pc' as string]: p.acc }} onClick={() => { if (!cur) setTarget(id); }}
              >
                <XFace ch={id} e={1} s={52} ring={p.acc} alt="" />
                <span class={s.two} style={{ flex: 1 }}><span class={s.personName}>{p.name}</span><span class={s.small}>{p.role}</span></span>
                {cur && <span class={s.curTag}>CURRENT</span>}
              </button>
            );
          })}
        </div>
      </ScrollArea>
      <BottomSheet open={!!t} onClose={() => setTarget(null)} label={t ? `Switch to ${t.name}?` : 'Switch buddy'} bg="rgba(28,25,22,0.99)">
        {t && target && (
          <>
            <div class={s.confirmHead}>
              <XFace ch={target} e={4} s={56} ring={t.acc} alt="" />
              <p class={s.sheetT}>{`Switch to ${t.name}?`}</p>
            </div>
            <p class={s.sheetSub} style={{ marginTop: 0 }}>{ME.switchBody(t.name)}</p>
            <PrimaryButton h={56} data-cta="switch" busy={busy} style={{ background: t.acc, color: '#14110D' }} onClick={() => void doSwitch()}>Switch</PrimaryButton>
            <TextButton onClick={() => setTarget(null)}>Cancel</TextButton>
          </>
        )}
      </BottomSheet>
    </Screen>
  );
}
